import { colors } from '@insurancemenu/imenu-components-lib';
import { InfoButton } from '@insurancemenu/imenu-components-lib/dist/icons';
import styled from 'styled-components';

export const InfoButtonStyled = styled(InfoButton)`
  width: 3.5rem;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  color: ${colors.blue[600]};
`;

export const InfoSectionStyled = styled.div`
  text-align: center;
  margin: 0 auto 6rem;
  padding: 2rem 6rem;
  box-sizing: border-box;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
`;

export const InfoTextStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.2rem;
`;
